module.exports = __webpack_public_path__ + "static/media/PipeofInsight.42a504c1.png";